import React from "react";
import { Layout, Menu } from "antd";
import {
  HomeOutlined,
  AppstoreOutlined,
  SmileOutlined,
  EnvironmentOutlined,
  BookOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Sider } = Layout;

export default function Sidebar() {
  return (
    <Sider collapsible theme="light"> 
      <Menu mode="inline" defaultSelectedKeys={["dashboard"]}>
        <Menu.Item key="dashboard" icon={<HomeOutlined />}>
          <Link to="/dashboard">Dashboard</Link>
        </Menu.Item>
        <Menu.Item key="bookings" icon={<BookOutlined />}>
          <Link to="/bookings">Bookings</Link>
        </Menu.Item>
        <Menu.Item key="destinations" icon={<EnvironmentOutlined />}>
        <Link to="/countries">Destinations</Link>
        </Menu.Item>
        <Menu.Item key="activities" icon={<SmileOutlined />}>
          <Link to="/activities_excursions">Activities & Excusrions</Link>
        </Menu.Item>
        <Menu.Item key="packages" icon={<AppstoreOutlined />}>
          <Link to="/packages">Packages</Link>
        </Menu.Item>
        <Menu.Item key="users" icon={<UserOutlined />}>
          <Link to="/users">Users</Link>
        </Menu.Item>
        <Menu.Item key="countries" icon={<UserOutlined />}>
          <Link to="/countries">Countries</Link>
        </Menu.Item>
         <Menu.Item key="cities" icon={<UserOutlined />}>
          <Link to="/cities">Cities</Link>
        </Menu.Item>
        <Menu.Item key="stays" icon={<UserOutlined />}>
          <Link to="/stays">Stays</Link>
        </Menu.Item>
         <Menu.Item key="tags" icon={<UserOutlined />}>
          <Link to="/tags">Tags</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
}
